import {BASE_URL, START, SPREADSHEET_START} from '../constants/urls'

const errorHandler = response => {
    if(!response.ok) throw Error(response.statusText);
    return response;
}

export const startSystemMigration = migration => {
    return fetch(`${BASE_URL}${START}`, {
        body: JSON.stringify(migration),
        method: 'POST',
        headers: {
            'content-type': 'application/json'
        }
    }).then(errorHandler)
}

export const startSpreadsheetMigration = migration => {
    const formData = new FormData();
    Object.keys(migration).forEach(key => formData.append(key, migration[key]));
    return fetch(`${BASE_URL}${SPREADSHEET_START}`, {
        body: formData,
        method: 'POST'
    }).then(errorHandler)
}


// WEBPACK FOOTER //
// ./src/js/services/start/startService.js